// extracted by mini-css-extract-plugin
module.exports = {"description":"RenameModal_description__C9_5h"};